import axios from 'axios';

const inspectionApi = axios.create({
    baseURL: process.env.REACT_APP_INSPECTION_API_URL
});

export default inspectionApi;